import axios from '@/utils/axios'

export const getSemiLatestCost = (payload) => {
    return axios.get('/semi_item_latest_cost', {
        params: payload
    })
}

export const getSemiLatestCostDetail = (payload) => {
    return axios.get(`/semi_latest_cost_detail/${payload}`)
}

export const calcSemiCost = (payload) => {
    return axios.post('/calc_semi_cost', payload)
}
